import CheckboxWithConditionalComment from 'parog-web/components/checkbox-with-conditional-comment';
import JournalEventBasedComponent from 'parog-web/components/forc/abstract/journal-event-based-component';
import Provider from 'parog-web/components/forc/provider';
import JournalEventRetrievalStrategies from 'parog-web/components/forc/utils/journal-event-retrieval-strategies';
import MedicinesReconciliationChangedJeournalEvent from 'parog-web/models/medicines-reconciliation-changed-journal-event';
export default class MedicinesReconciliationFormComponent extends JournalEventBasedComponent {
  static override forcDisplayName =
    'Conciliation pharmaceutique et éducation thérapeutique';
  static override fullComponentId = 'medicines-reconsiliation/edition-form';
  static override journalEventClass =
    MedicinesReconciliationChangedJeournalEvent;

  override journalEventProperties = [
    'occurredAt',
    'medicinesReconciliation',
    'educationalTherapy'
  ];
  override retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  override computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();
    return payload;
  }

  <template>
    <Provider @forcComponent={{this}}>
      <:content as |Form|>
        <CheckboxWithConditionalComment
          @labelName='Conciliation pharmaceutique'
          @propertyName='medicinesReconciliation'
          @form={{Form}}
          @changeset={{this.changeset}}
        />
        <CheckboxWithConditionalComment
          @labelName='Éducation thérapeutique'
          @propertyName='educationalTherapy'
          @form={{Form}}
          @changeset={{this.changeset}}
        />
      </:content>
    </Provider>
  </template>
}
